import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fs12 mb20 mt20" }, " ステップ1から順に日程を提案してもらいます。同一グループは前のグループが提案完了すると、同時にメールが送られます。 ", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "mb10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fl mt12 fs13 mr5" }, "ステップ", -1)
const _hoisted_6 = {
  class: "kireiOrangeBg fl rad10 whiteColor pad5 fs16 mt5 mr5 centered",
  style: {"width":"30px","height":"30px"}
}
const _hoisted_7 = { class: "" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = { class: "lskyblueBg rad8 pointer fs12 fw600 hoverLgreyBg w95 pad10" }
const _hoisted_11 = {
  class: "posAb",
  style: {"width":"18px","top":"-5px","right":"-5px"}
}
const _hoisted_12 = ["src", "onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { class: "centered" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "mb10" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "fl mt12 fs13 mr5" }, "ステップ", -1)
const _hoisted_21 = {
  class: "kireiOrangeBg fl rad10 whiteColor pad5 fs16 mt5 mr5 centered",
  style: {"width":"30px","height":"30px"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_24 = { class: "centered" }
const _hoisted_25 = ["src"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_29 = {
  key: 0,
  class: "mt10"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fl mt10 fw600 mr5" }, "決定者", -1)
const _hoisted_31 = { class: "fl ml10 fs12" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = { class: "fs12" }
const _hoisted_34 = {
  key: 1,
  class: "mt10"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fl mt10 fw600 mr5" }, "承認者", -1)
const _hoisted_36 = { class: "fl ml10 fs12" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = { class: "fs12" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (sec, secindex) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "w100",
          key: `${secindex}${sec.length}`
        }, [
          (sec.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, _toDisplayString(secindex + 1), 1),
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/vote.png`),
                      width: "20",
                      height: "20",
                      class: "fl ml15 mt8"
                    }, null, 8, _hoisted_8), [
                      [_directive_tooltip, 
                                    `${secindex == 0 ? `` : `ステップ${secindex + 1}の空いている候補の中から`}複数候補を提案`
                                ]
                    ])
                  ]),
                  _hoisted_9
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_draggable, {
                    modelValue: _ctx.sections[secindex],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.sections[secindex]) = $event),
                    group: { name: 'members', pull: true, put: true },
                    onStart: _ctx.startDrag,
                    onEnd: _ctx.sortEnd,
                    onChange: event => _ctx.handleChange(event, secindex),
                    "item-key": `user_id`
                  }, {
                    item: _withCtx(({ element: mem, index: memindex }) => [
                      (_openBlock(), _createElementBlock("div", {
                        class: "fl mr10 posRe mb20",
                        key: mem.user_id
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/icons/dismiss_grey_dgrey.png`),
                            width: "18",
                            height: "18",
                            class: "fr pointer",
                            onClick: ($event: any) => (_ctx.deleteSectionMem(mem))
                          }, null, 8, _hoisted_12)
                        ]),
                        _createVNode(_component_UserIcon, {
                          member: mem,
                          width: 45,
                          canEdit: false,
                          updateSelf: false,
                          showTooltip: true,
                          class: "pointer",
                          onClick: ($event: any) => (_ctx.selectMember(mem))
                        }, null, 8, ["member", "onClick"])
                      ]))
                    ]),
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue", "onStart", "onEnd", "onChange"]),
                  _hoisted_14
                ]),
                _hoisted_15,
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/ar_down.png`),
                      width: "18",
                      height: "18",
                      class: "mc centered"
                    }, null, 8, _hoisted_17)
                  ])
                ])
              ]))
            : (secindex == 0 || _ctx.sections[secindex - 1].length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, _toDisplayString(secindex + 1), 1),
                    _hoisted_22
                  ]),
                  _createVNode(_component_draggable, {
                    modelValue: _ctx.sections,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sections) = $event)),
                    group: { name: 'sections', pull: true, put: true },
                    onStart: _ctx.startDrag,
                    onEnd: _ctx.sortEnd,
                    onChange: event => _ctx.handleChange(event, secindex),
                    "item-key": `user_id`,
                    class: "lskyblueBg rad8 pointer fs12 fw600 hoverLgreyBg w95",
                    style: { minHeight: `100px` }
                  }, {
                    item: _withCtx(({ element: mem, index: memindex }) => [
                      (_openBlock(), _createElementBlock("div", {
                        class: "fl mr10 posRe mb20",
                        key: mem.user_id
                      }))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onStart", "onEnd", "onChange"]),
                  _hoisted_23,
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(`/assets/icons/ar_down.png`),
                        width: "18",
                        height: "18",
                        class: "mc centered"
                      }, null, 8, _hoisted_25)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
        ]))
      }), 128)),
      _hoisted_26,
      _createElementVNode("div", null, [
        _hoisted_27,
        _createElementVNode("div", {
          class: "w100 pad10 circle_button blueAround rad8 mt20 centered fw600",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addFixMem && _ctx.addFixMem(...args)))
        }, " 🙋日程決定者または🤖AIを設定 "),
        _hoisted_28,
        (_ctx.fixMem)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_UserIcon, {
                class: "fl",
                member: _ctx.fixMem,
                width: 30,
                canEdit: false,
                updateSelf: false,
                showTooltip: false
              }, null, 8, ["member"]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("span", null, _toDisplayString(_ctx.fixMem.name), 1),
                _hoisted_32,
                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.fixMem.email), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.approvalMem)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _hoisted_35,
              _createVNode(_component_UserIcon, {
                class: "fl",
                member: _ctx.approvalMem,
                width: 45,
                canEdit: false,
                updateSelf: false,
                showTooltip: true
              }, null, 8, ["member"]),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("span", null, _toDisplayString(_ctx.approvalMem.name), 1),
                _hoisted_37,
                _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.approvalMem.email), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_39
  ]))
}